import { motion } from "framer-motion";
import { Phone, Clock } from "lucide-react";
import { HOURS, PHONE, PHONE_LINK, isOpenNow } from "../data/menu";

const DAYS_DE = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];

export const Hours = () => {
  const open = isOpenNow();
  const today = DAYS_DE[new Date().getDay()];

  return (
    <section id="oeffnungszeiten" data-testid="hours-section" className="relative z-10 bg-[#F0EFEA]/70 py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 md:grid-cols-12 md:px-10">
        <div className="md:col-span-5">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="mb-6 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.28em] text-[#78825B]"
          >
            <Clock size={14} strokeWidth={1.5} />
            Öffnungszeiten
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, delay: 0.05 }}
            className="font-display text-4xl font-light leading-none tracking-tight text-[#1A1C19] sm:text-5xl"
          >
            Wann wir für Sie{" "}
            <span className="italic text-[#4B7F94]">da sind</span>
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="mt-8"
          >
            <span
              data-testid="hours-open-badge"
              className="inline-flex items-center gap-2 rounded-full border border-[#E2E0D8] bg-white/70 px-5 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-[#1A1C19]"
            >
              <span className={`pulse-dot h-2 w-2 rounded-full ${open ? "bg-[#78825B]" : "bg-[#C9A227]"}`} />
              {open ? "Jetzt geöffnet" : "Zurzeit geschlossen"}
            </span>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#4A4D46]">
              Am schnellsten geht's per Anruf — je nach Tageszeit in ca. 10 bis 40 Minuten abholbereit.
            </p>
            <a
              href={PHONE_LINK}
              data-testid="hours-call-button"
              className="mt-6 inline-flex items-center gap-3 rounded-full bg-[#1A1C19] px-8 py-4 text-sm font-semibold tracking-wide text-[#F9F8F6] transition-all duration-300 hover:-translate-y-1 hover:bg-[#4B7F94]"
            >
              <Phone size={16} strokeWidth={1.5} />
              {PHONE}
            </a>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="md:col-span-6 md:col-start-7"
          data-testid="hours-table"
        >
          {HOURS.map((h) => {
            const isToday = h.day === today;
            return (
              <div
                key={h.day}
                data-testid={`hours-row-${h.day.toLowerCase()}`}
                className={`flex items-baseline justify-between border-b border-[#E2E0D8] px-4 py-5 transition-colors duration-300 ${
                  isToday ? "bg-white/70" : ""
                }`}
              >
                <span className="flex items-center gap-3 text-base font-semibold uppercase tracking-[0.12em] text-[#1A1C19]">
                  {h.day}
                  {isToday && (
                    <span className="rounded-full bg-[#4B7F94]/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.15em] text-[#4B7F94]">
                      Heute
                    </span>
                  )}
                </span>
                <span
                  className={`font-display text-xl tracking-tight ${
                    h.closed ? "italic text-[#3D403A]/60" : "text-[#1A1C19]"
                  }`}
                >
                  {h.time}
                </span>
              </div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
